import { useTranslation } from 'react-i18next'

import { HTML_DATA_PARAM_OUTSIDE_TRIGGER } from '../../../../constants/html'
import Button, { BUTTON_HEIGHT_16, ButtonArrow } from '../../../Button'

import {
  QA_NAME_ADD_BCC_BTN,
  QA_NAME_ADD_CC_BTN,
  QA_NAME_RECIPIENTS_FILTER_BTN,
} from './SelectButtonActions.constants'

import * as styles from './SelectButtonActions.module.css'

import FilterIcon from '../../../../icons/filter-settings.svg'

function SelectButtonActions({
  FilterButton = Button.Text,
  blocked,
  isOpen,
  ref,
  viewBcc,
  viewCc,
  onClickBcc,
  onClickCc,
  onClickOpen,
  onOpenFilterModal,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.SelectButtonActions} ref={ref}>
      {FilterButton ? (
        <Button.Text
          isGrey
          beforeIconProps={{ Icon: FilterIcon }}
          dataProps={{
            [HTML_DATA_PARAM_OUTSIDE_TRIGGER]: true,
          }}
          height={BUTTON_HEIGHT_16}
          qaName={QA_NAME_RECIPIENTS_FILTER_BTN}
          tooltip={t('Email.AddRecipientsFilterKey')}
          onClick={onOpenFilterModal}
        />
      ) : null}
      {viewCc ? (
        <Button.Text
          isGrey
          className={styles.button}
          height={24}
          qaName={QA_NAME_ADD_CC_BTN}
          text={t('Email.CcBtnKey')}
          onClick={onClickCc}
        />
      ) : null}
      {viewBcc ? (
        <Button.Text
          isGrey
          className={styles.button}
          height={24}
          qaName={QA_NAME_ADD_BCC_BTN}
          text={t('Email.BccBtnKey')}
          onClick={onClickBcc}
        />
      ) : null}
      {blocked ? null : <ButtonArrow isOpen={isOpen} onClick={onClickOpen} />}
    </div>
  )
}

export default SelectButtonActions
